import { supertypeClass, property, Persistable, Supertype } from '@haventech/amorphic';

import { AccountAuthorization } from './authorization/AccountAuthorization';
import { Deprecable } from '../Deprecable';
import { FullIdentity, Identity } from './identity/Identity';

export enum OnlineAccountProvider {
  AUTH0 = 'Auth0',
  AMC = 'AMC',
}

export enum OnlineAccountStatuses {
  locked = 'locked',
  linkingPending = 'linkingPending',
  unauthorized = 'unauthorized',
  legacy = 'legacy',
  primaryIdentityNotFound = 'primaryIdentityNotFound',
  authorized = 'authorized',
}
export interface OnlineAccountAccess {
  accountCreatedTime: Date;
  accountId?: string;
  identities: FullIdentity[];
  status: OnlineAccountStatuses;
  identityProvider?: string;
  accountAuthorizationCreatedTime?: Date;
}
@supertypeClass({ toClient: true, toServer: false })
export class Account extends Persistable(Supertype) implements Deprecable {
  @property({
    toServer: false,
    toClient: false,
    comment: `true if an account is active.
                  An account is only ever deactivated via manual intervention by customer support.`,
  })
  isActive: boolean;

  @property({
    type: Array,
    toServer: false,
    getType: () => Identity,
    comment: 'identities linked to the account.  An account can have many identities linked.',
  })
  identities: Array<Identity> = [];

  @property({
    type: Array,
    toServer: false,
    getType: () => AccountAuthorization,
    comment: 'the links that give an account authority to access a managed entity',
  })
  accountAuthorizations: Array<AccountAuthorization> = [];

  @property({
    toServer: false,
    toClient: true,
    comment: 'if true an auth0 user has not been created yet for an identity',
  })
  linkingPending: boolean;

  @property({
    comment: 'timestamp',
    toServer: false,
  })
  createdTime: Date;

  @property({
    toServer: false,
    toClient: false,
    comment: `Dummy Column - Keeps DTC and CP in sync`,
  })
  externalId: string;

  private constructor() {
    super();
  }

  static new(identity?: Identity): Account {
    return new Account().init(identity);
  }

  private init(identity?: Identity): Account {
    this.identities.push(identity);

    this.isActive = true;

    return this;
  }

  get allIdentities() {
    return this.identities;
  }

  get activeIdentities() {
    const activeIdentities: Array<Identity> = [];
    this.identities.forEach((identity) => {
      if (identity.isActive && activeIdentities.indexOf(identity) === -1) {
        activeIdentities.push(identity);
      }
    });
    return activeIdentities;
  }
}
